export default __webpack_public_path__ + "static/media/my-library-white.bef233e4.svg";